export default "<button class=\"transparent-button\"><fa-icon [icon]=\"faArrowCircleLeft\"></fa-icon><ng-content></ng-content></button>\n"